//defs
import { TurboPaymentCommsType } from "@payment-ui/interfaces";

// condition to display turbo tooltip
export const showTurboTooltip = (commsType: TurboPaymentCommsType | null, hideEducationComms: boolean) => {
    return !commsType && !hideEducationComms;
};
